import React, { FC } from "react";
import styles from "./ExploreTabs.module.css";
import Union from "assets/svgs/Union";
import clsx from "clsx";
import { All } from "assets/svgs";

interface Props {
  tab?: "all" | "Upcoming" | "open" | "ended";
  setTab: React.Dispatch<
    React.SetStateAction<"all" | "Upcoming" | "open" | "ended">
  >;
}

const ExploreTabs: FC<Props> = ({ tab = "onGoing", setTab }) => {
  return (
    <div className={styles.root}>
      <button
        onClick={() => setTab("all")}
        className={clsx(styles.tab, {
          [styles.active]: tab === "all",
        })}
      >
        <span>
          <All active={false} />
        </span>
        All
      </button>
      <button
        onClick={() => setTab("Upcoming")}
        className={clsx(styles.tab, { [styles.active]: tab === "Upcoming" })}
      >
        <span>
          <Union />
        </span>
        Coming Soon
      </button>

      <button
        onClick={() => setTab("open")}
        className={clsx(styles.tab, { [styles.active]: tab === "open" })}
      >
        <span>
          <Union />
        </span>
        Ongoing
      </button>

      <button
        onClick={() => setTab("ended")}
        className={clsx(styles.tab, { [styles.active]: tab === "ended" })}
      >
        <span>
          <Union />
        </span>
        Completed
      </button>
    </div>
  );
};

export default ExploreTabs;
